export class MessageHandlerStateWrapper {
    constructor(inner) {
        this.inner = inner;
    }
    get_inner() {
        return this.inner;
    }
}
//# sourceMappingURL=MessageHandlerStateWrapper.js.map